import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function submitContact(payload) {
  const { data } = await axios.post(`${API}/contact`, payload);
  return data;
}

export async function submitDemo(payload) {
  const { data } = await axios.post(`${API}/demo`, payload);
  return data;
}
